import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionSummary, Alert, Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import {
  useGetPendingCurrencyExchangeInstructionsQuery
} from '../../../../api/currency-exchanges/currencyExchangeInstructionApi'
import type { AssetHolderUpdateDto } from '../../../../api/schema-dtos/AssetHolderCrudDtos'
import { type LedgerAccountDetails } from '../../../../api/schema-dtos/AssetHolderFinancePayloadDtos'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import ErrorComponent from '../../../shared/components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../shared/components/ui-widgets/LoadingComponent'
import type { AssetHolderIdProps } from '../../pages/DashboardHome'
import CreateExchangeInstructionComponent from './CreateExchangeInstructionComponent'
import ExchangeInstructionsComponent from './ExchangeInstructionsComponent'

interface ComponentProps extends AssetHolderIdProps {
  wallets: LedgerAccountDetails[]
  assetHolder: AssetHolderUpdateDto
  verticalSpacing: number
  maxCardWidth: number
}

const AccordionExchangeInstructions: React.FC<ComponentProps> = ({ assetHolderId, wallets, assetHolder, verticalSpacing, maxCardWidth }: ComponentProps) => {
  const [expanded, setExpanded] = useState<boolean>(false)
  const getPendingExchangeInstructionsApiResult = useGetPendingCurrencyExchangeInstructionsQuery(assetHolderId)

  const accordionIdentifier = `dashboard-exchange-instructions-${assetHolderId}`

  return (
    <>
      <Accordion sx={{ px: 4, pt: 2 }} expanded={expanded} onChange={(evt, expanded) => { setExpanded(expanded) }} >

        <AccordionSummary expandIcon={<ExpandMoreIcon color={'primary'}/>}
                          aria-controls={accordionIdentifier}
                          id={accordionIdentifier} sx={{ px: 0, pb: 2 }}>
          {/* <Typography variant={'body1'}>Donate all your balances to a selected charity</Typography> */}
          <Typography variant={'h3'} sx={{ mb: 1 }}>Converting ZAR payout balance to BTC</Typography>
        </AccordionSummary>

        <Box sx={{ pb: 4 }}>

          {getPendingExchangeInstructionsApiResult.isLoading && <LoadingComponent/>}
          {getPendingExchangeInstructionsApiResult.isError &&
            <ErrorComponent
              message={RtkQueryHelper.mapResponseError(getPendingExchangeInstructionsApiResult.error)}/>}

          {!assetHolder.hasPassedKyc &&
            <Box sx={{ my: verticalSpacing, maxWidth: maxCardWidth }}>
              <Alert severity="warning" sx={{ mt: 3 }}>
                <b>Note:</b> Please complete your KYC on the &apos;My Profile&apos; tab in order to schedule a ZAR Payout in BTC request.
              </Alert>
            </Box>
          }

          {getPendingExchangeInstructionsApiResult.isSuccess &&
            <ExchangeInstructionsComponent
              assetHolderId={assetHolderId}
              instructions={getPendingExchangeInstructionsApiResult.data}
              maxCardWidth={maxCardWidth}
            />
          }

          <Box>
            {getPendingExchangeInstructionsApiResult.isSuccess && (
              <CreateExchangeInstructionComponent
                assetHolderId={assetHolderId}
                wallets={wallets}
                hasPassedKyc={assetHolder.hasPassedKyc}
                maxCardWidth={maxCardWidth}
                existingInstructions={getPendingExchangeInstructionsApiResult.data}/>
            )}
          </Box>

        </Box>

      </Accordion>
    </>
  )
}

export default AccordionExchangeInstructions
